import React, { useState } from 'react';
import { FetchData, SORT_DIRECTION, SortModel, Table, WithFetch, WithTableLayout } from '@qrios/frontend-library';
import { fetchWithTokenRefresh } from '../../../../../../api/fetchWithTokenRefresh';
import endpoints from '../../../../../../api/endpoints';
import TableFooterInfo from '../../../../../common/table/footerInfo';
import { VoiceAppsResponse } from './interfaces';
import { mapApiDataIntoTableFormat } from './dataTransformator';
import { columns } from './columns';
import locales from './locales';
import { useEditApp } from './useEditApp';
import { Dialog } from '../../../../../common/dialog';
import EditAppForm from './forms/editForm';
import Message from '../../../../../common/message';

const Apps = () => {
  const [sortModel, setSortModel] = useState<SortModel>([{ field: 'createDate', sort: SORT_DIRECTION.ASC }]);

  const {
    error: editError,
    initEditFormData,
    isEditAppLoading,
    isEditAppDialogOpen,
    handleOpenEditAppDialog,
    handleCloseEditAppDialog,
    handleSubmitEditAppDialog
  } = useEditApp();

  const tableRowActions = {
    edit: handleOpenEditAppDialog
  };

  return (
    <>
      <WithFetch
        fetchProvider={fetchWithTokenRefresh}
        pathname={endpoints.voiceApps}
        withLoader={false}
        withError={false}
      >
        {({ data, refresh, loading, error, previousOptions }: FetchData<VoiceAppsResponse | undefined>) => (
          <WithTableLayout>
            <Table
              dataGridProps={{
                rows: !data?.apps || loading ? [] : mapApiDataIntoTableFormat(data.apps, tableRowActions),
                columns,
                loading,
                error: {
                  message: error,
                  refresh: () => refresh(previousOptions)
                },
                emptyMsg: locales.table.emptyMsg,
                sortModel,
                onSortModelChange: (model: SortModel) => setSortModel(model)
              }}
              headProps={{
                warningMsg: loading || !data ? undefined : 'You reached the max number of owned Voice Apps.'
              }}
              footerProps={{
                tableInfo: (
                  <TableFooterInfo
                    label={locales.footer.label}
                    tooltip={locales.footer.tooltip}
                    value={
                      !data || loading
                        ? '-'
                        : `${data.limits.createdLimit.itemsCount} of ${data.limits.createdLimit.limit}`
                    }
                  />
                ),
                refreshProps: {
                  disabled: loading,
                  handler: () => {
                    refresh(previousOptions);
                  }
                }
              }}
            />
            {initEditFormData && (
              <Dialog
                open={isEditAppDialogOpen}
                title={locales.dialog.edit.title}
                handleClose={handleCloseEditAppDialog}
              >
                <Message severity="success">
                  {({ setIsPopupOpen, setPopupMessage }) => (
                    <EditAppForm
                      initialVoiceAppFormData={initEditFormData}
                      loading={isEditAppLoading}
                      onClose={handleCloseEditAppDialog}
                      onSubmit={props => {
                        handleSubmitEditAppDialog(props, () => refresh(previousOptions));
                      }}
                      error={editError}
                      popup={{
                        setStateCallback: setIsPopupOpen,
                        setMsgCallback: setPopupMessage
                      }}
                    />
                  )}
                </Message>
              </Dialog>
            )}
          </WithTableLayout>
        )}
      </WithFetch>
    </>
  );
};

export default Apps;
